import { useMemo } from 'react';
import { useLocation, useMatch, useNavigate, useParams } from 'react-router-dom';
import queryString from 'query-string';

const useRouter = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const match = useMatch;
  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    return {
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      match,
      location,
      navigate,
    };
  }, [params, match, location, navigate]);
};

export default useRouter;
